import React from 'react';
import moment from 'moment';
import { dateFormatZurich } from 'utils/datetime';
import { TYPE_OF_ORDER_TITLES } from 'widgets/CaseManagement/TypeOfOrder/TypeOfOrder';
import { Icon } from 'ui-library';
import { ICON_LONG_ARROW_RIGHT } from 'ui-library/components/Icon';
import { CaseOrderStatus } from 'components/DocBox/DocBox.types';

export const getOrderType = ({ isPk, orderType }) => {
    if (isPk && orderType === 1) {
        return 'OrderType.PK.PaymentOrder';
    }

    return TYPE_OF_ORDER_TITLES?.[orderType];
};

export const adaptCasesInProgressData = ({
    data,
    t,
    onNavigationClick,
    isPk,
}) => data?.map((item) => ({
    case_id: item?.id,
    date: moment(item?.createdDate)?.format(dateFormatZurich) || '',
    advisor: item?.advisorName || '',
    type: t(getOrderType({ isPk, orderType: item?.orderType })),
    status: item?.orderStatus === CaseOrderStatus.Cancelled ? t('DL.ViewCases.Status.aborted') : t('applicationTable.status.InProgress'),
    caseDetails: (
        <Icon
            type={ICON_LONG_ARROW_RIGHT}
            className="navigationButtonArrow"
            onClick={() => onNavigationClick({ caseId: item?.id })}
        />
    ),
})) || [];

export const adaptSubmittedCasesData = ({
    data,
    t,
    isPk,
    onNavigationClick,
}) => data?.map((caseData) => ({
    case_id: `${caseData?.lpzCaseId}`,
    date:
                moment(caseData?.lastModified).format('DD.MM.YYYY HH:MM')
                || '-',
    advisor: caseData?.submittedBy || '-',
    typeId: caseData?.type,
    type: t(
        getOrderType({
            isPk,
            orderType: caseData?.type,
        }),
    ),
    status: t(`DL.ViewCases.Status.${caseData?.status}`) || '-',
    statusId: caseData?.status,
    caseDetails: (
        <Icon
            type={ICON_LONG_ARROW_RIGHT}
            className="navigationButtonArrow"
            onClick={() => onNavigationClick({
                caseId: caseData?.id,
                externalId: caseData?.externalId,
            })}
        />
    ),
}));

export const useGetSubmittedCasesData = ({
    dataFromAPI,
    typeFilter,
    statusFilter,
}) => {
    const data = dataFromAPI
        ?.filter((f) => !statusFilter || f.statusId === statusFilter)
        .filter((f) => !typeFilter || f.typeId === typeFilter);

    return { data };
};
